<template>
  <div class="container-fluid">
    <Loading v-if="this.$store.state.isLoading" />
    <AlertDialog v-if="this.$store.state.isAlertDialog" />
    <div
      class="row header bt-primary justify-content-between align-items-center"
    >
      <div class="col-auto">
        <img
          class="titleimg"
          src="@/assets/acrypro/logo.svg"
          style="cursor: pointer"
          @click="backhome"
        />
      </div>
      <div class="col-auto">
        <a href="#" class="text-dark me-3" style="text-decoration: none" @click="contact">お問い合わせ</a>
      </div>
    </div>
    <div class="row" style="height: 40px"></div>
    <div class="row mb-5">
      <div class="col text-center">
        <p class="noto acry-foreground h3 fw-bold">アカウント設定</p>
      </div>
    </div>
    <template>
      <div class="row justify-content-center d-flex mt-4 mb-1">
        <div class="col-3 text-start">
          <input type="radio" id="corporation" value="" class="me-2" v-model="isIndividual" style="width:24px; height:24px; accent-color:#8593bc;" />
          <label for="corporation" class="fw-bold" style="vertical-align: top;">法人</label>
        </div>
        <div class="col-3 text-start">
          <input type="radio" id="individual" value="true" class="me-2" v-model="isIndividual"  style="width:24px; height:24px; accent-color:#8593bc;" />
          <label for="individual" class="fw-bold" style="vertical-align: top;">個人</label>
        </div>
        <div class="col-4">
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-10">
          <hr />
        </div>
      </div>
      <div class="row justify-content-center mt-1">
        <div class="col-3 text-start">
          <span class="fw-bold">責任者名</span><span class="mustlbl ms-2">必須</span>
        </div>
        <div class="col-7">
          <div class="d-flex flex-row gap-3">
            <div>
              <div class="mb-2 text-start">
                <label for="inputName" class="form-label fw-bold">氏名</label>
                <input
                  type="text"
                  id="inputName"
                  v-model="name01"
                  class="mt-1 acry-input d-block"
                  :class="{ 'acry-input-error': this.name01error }"
                  placeholder="姓"
                />
              </div>
            </div>
            <div>
              <div class="mb-2 text-start">
                <label for="inputName2" class="form-label" style="visibility: hidden"
                  >名</label
                >
                <input
                  type="text"
                  id="inputName2"
                  v-model="name02"
                  :class="{ 'acry-input-error': name02error }"
                  class="mt-1 acry-input d-block"
                  placeholder="名"
                />
              </div>
            </div>
          </div>
          <div class="d-flex flex-row gap-3 mt-2">
            <div>
              <div class="mb-2 text-start">
                <label for="inputNameKana" class="form-label fw-bold">セイ</label>
                <input
                  type="text"
                  id="inputNameKana"
                  v-model="kana01"
                  :class="{ 'acry-input-error': kana01error }"
                  class="mt-1 acry-input d-block"
                  placeholder="カナ"
                />
              </div>
            </div>
            <div>
              <div class="mb-2 text-start">
                <label for="inputName2Kana" class="form-label" style="visibility: hidden"
                  >メイ</label
                >
                <input
                  type="text"
                  id="inputName2Kana"
                  v-model="kana02"
                  :class="{ 'acry-input-error': kana02error }"
                  class="mt-1 acry-input d-block"
                  placeholder="メイ"
                />
              </div>
            </div>
          </div>
          <div class="text-start error-lbl small">
            <p v-if="this.name01error">{{name01ErrorText}}</p>
            <p v-if="this.name02error">{{name02ErrorText}}</p>
            <p v-if="this.kana01error">{{kana01ErrorText}}</p>
            <p v-if="this.kana02error">{{kana02ErrorText}}</p>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-10">
          <hr />
        </div>
      </div>

      <!-- 法人用フォーム -->
      <div v-if="!isIndividual" >
        <div class="row justify-content-center mt-1 mb-2">
          <div class="col-3 text-start">
            <span class="fw-bold">会社名</span><span class="mustlbl ms-2">必須</span>
          </div>
          <div class="col-7">
            <div class="text-start">
              <input
                type="text"
                id="address"
                :class="{ 'acry-input-error': yagouerror }"
                class="mt-1 acry-input d-block"
                v-model="yagou"
                style="width: 616px"
                placeholder="〇〇株式会社"
              />
            </div>
            <div class="text-start error-lbl small pt-2">
              <p v-if="this.yagouerror">{{yagouErrorText}}</p>
            </div>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-10">
            <hr />
          </div>
        </div>
        <div class="row justify-content-center mt-1 mb-2">
          <div class="col-3 text-start">
            <span class="fw-bold">代表者名</span><span class="mustlbl ms-2">必須</span>
          </div>
          <div class="col-7">
            <div class="text-start">
              <input
                type="text"
                id="address"
                :class="{ 'acry-input-error': representativeerror }"
                class="mt-1 acry-input d-block"
                v-model="representative"
                style="width: 616px"
                placeholder="代表取締役 〇〇 〇〇"
              />
            </div>
            <div class="text-start error-lbl small pt-2">
              <p v-if="this.representativeerror">代表者名を入力してください</p>
            </div>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-10">
            <hr />
          </div>
        </div>
        <div class="row justify-content-center mt-1 mb-2">
          <div class="col-3 text-start">
            <span class="fw-bold">部署名</span><span class="mustlbl ms-2">必須</span>
          </div>
          <div class="col-7">
            <div class="text-start">
              <input
                type="text"
                id="address"
                class="mt-1 acry-input d-block"
                v-model="busyo"
                :class="{ 'acry-input-error': busyoerror }"
                style="width: 616px"
                placeholder="〇〇部"
              />
            </div>
            <div class="text-start error-lbl small pt-2">
              <p v-if="this.busyoerror">{{busyoErrorText}}</p>
            </div>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-10">
            <hr />
          </div>
        </div>
      </div>

      <!-- 個人用フォーム -->
      <div v-if="isIndividual" >
        <div class="row justify-content-center mt-1 mb-2">
          <div class="col-3 text-start">
            <span class="fw-bold">屋号</span>
            <!-- <span class="mustlbl ms-2">必須</span> -->
          </div>
          <div class="col-7">
            <div class="text-start">
              <input
                type="text"
                id="address"
                class="mt-1 acry-input d-block"
                v-model="yagou"
                :class="{ 'acry-input-error': yagouerror }"
                style="width: 616px"
                placeholder=""
              />
            </div>
            <div class="text-start error-lbl small pt-2">
              <p v-if="this.yagouerror">{{yagouErrorText}}</p>
            </div>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-10">
            <hr />
          </div>
        </div>
      </div>

      <div class="row justify-content-center mt-1">
        <div class="col-3 text-start">
          <span class="fw-bold">住所</span><span class="mustlbl ms-2">必須</span>
        </div>
        <div class="col-7">
          <div class="text-start">
            〒
            <input
              type="text"
              id="inputCode"
              class="mt-1 acry-input"
              v-model="zip"
              :class="{ 'acry-input-error': ziperror }"
              maxlength="7"
              style="width: 129px"
              placeholder="0000000"
            />
            <button class="find-btn ms-2" @click="findAction">住所検索</button>
          </div>
          <select
            class="text-start form-select mt-3"
            name="pref_id"
            id="inputCity"
            v-model="pref"
            style="width: 160px; height: 40px; font-size: 14px"
            :class="{ 'acry-input-error': preferror }"
          >
            <option disabled value="default">都道府県を選択</option>

            <option value="1">北海道</option>
            <option value="2">青森県</option>
            <option value="3">岩手県</option>
            <option value="4">宮城県</option>
            <option value="5">秋田県</option>
            <option value="6">山形県</option>
            <option value="7">福島県</option>
            <option value="8">茨城県</option>
            <option value="9">栃木県</option>
            <option value="10">群馬県</option>
            <option value="11">埼玉県</option>
            <option value="12">千葉県</option>
            <option value="13">東京都</option>
            <option value="14">神奈川県</option>
            <option value="15">新潟県</option>
            <option value="16">富山県</option>
            <option value="17">石川県</option>
            <option value="18">福井県</option>
            <option value="19">山梨県</option>
            <option value="20">長野県</option>
            <option value="21">岐阜県</option>
            <option value="22">静岡県</option>
            <option value="23">愛知県</option>
            <option value="24">三重県</option>
            <option value="25">滋賀県</option>
            <option value="26">京都府</option>
            <option value="27">大阪府</option>
            <option value="28">兵庫県</option>
            <option value="29">奈良県</option>
            <option value="30">和歌山県</option>
            <option value="31">鳥取県</option>
            <option value="32">島根県</option>
            <option value="33">岡山県</option>
            <option value="34">広島県</option>
            <option value="35">山口県</option>
            <option value="36">徳島県</option>
            <option value="37">香川県</option>
            <option value="38">愛媛県</option>
            <option value="39">高知県</option>
            <option value="40">福岡県</option>
            <option value="41">佐賀県</option>
            <option value="42">長崎県</option>
            <option value="43">熊本県</option>
            <option value="44">大分県</option>
            <option value="45">宮崎県</option>
            <option value="46">鹿児島県</option>
            <option value="47">沖縄県</option>
          </select>

          <div class="text-start mt-3">
            <input
              type="address"
              id="address"
              class="mt-1 acry-input d-block"
              v-model="address01"
              :class="{ 'acry-input-error': address01error }"
              placeholder="市町村番地(例：大阪市北区○-○)"
              style="width: 616px"
            />
          </div>
          <div class="text-start mt-3">
            <input
              type="address"
              id="address"
              class="mt-1 acry-input d-block"
              v-model="address02"
              placeholder="ビル・マンション名"
              style="width: 616px"
            />
          </div>
          <div class="text-start error-lbl small pt-2">
            <p v-if="this.address01error || this.ziperror || this.preferror">
              住所を入力してください
            </p>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-10">
          <hr />
        </div>
      </div>
      <div class="row justify-content-center mt-1">
        <div class="col-3 text-start">
          <span class="fw-bold">電話番号</span><span class="mustlbl ms-2">必須</span>
        </div>
        <div class="col-7">
          <div class="row text-start">
            <div class="col-auto text-start">
              <input
                type="text"
                id="phone"
                class="mt-1 acry-input d-block"
                v-model="tel01"
                :class="{ 'acry-input-error': tel01error }"
                pattern="^[0-9]+$"
                style="width: 100px"
              />
            </div>
            <div class="col-auto p-0 m-0">
              <p class="text-dark m-0 p-0" style="line-height: 40px">-</p>
            </div>

            <div class="col-auto">
              <input
                type="text"
                id="phone"
                class="mt-1 acry-input d-block"
                v-model="tel02"
                :class="{ 'acry-input-error': tel02error }"
                pattern="^[0-9]+$"
                style="width: 100px"
              />
            </div>
            <div class="col-auto p-0 m-0">
              <p class="text-dark m-0 p-0" style="line-height: 40px">-</p>
            </div>

            <div class="col-auto">
              <input
                type="text"
                id="phone"
                class="mt-1 acry-input d-block"
                v-model="tel03"
                :class="{ 'acry-input-error': tel03error }"
                pattern="^[0-9]+$"
                style="width: 100px"
              />
            </div>
            <div class="col-2"></div>
          </div>
          <div class="text-start error-lbl small pt-1">
            <p v-if="this.tel01error || this.tel02error || this.tel03error">
              {{telErrorText}}
            </p>
          </div>
        </div>
        <div class="row justify-content-center mt-5 mb-3">
          <button type="button" class="border-0 acry-normal-btn" @click="sendAction">
            <span class="fw-bold">次へ</span>
          </button>
        </div>
      </div>
    </template>
    <template v-if="isEnd">
      <div class="row pl-3">
        <p>メールアドレス確認用メールを送信しました。</p>
        <br />
        <p>メールをご確認いただき認証を完了お願いします。</p>
      </div>
    </template>
  </div>
</template>

<script>
import { User } from "@/js/User.js";
import router from "../router";
import Loading from "@/components/modal/dialog/Loading.vue";
import AlertDialog from "@/components/acyrpro/modal/dialog/AlertDialog_Ap.vue";
import firebase from "firebase/app";
import "firebase/auth";
import { Analytics } from "@/js/Analytics.js";

export default {
  name: "AcryProForm",
  components: {
    Loading,
    AlertDialog,
  },
  props: {},
  async created() {
    // 登録されている住所の取得
    const userInfo = await User.getInfo().catch(() => {
      console.log("エラー");
    });

    const fbUserData = await User.getFBAcryProUserData().catch(() => {
      console.log("エラー");
    });

    if (userInfo != null) {
      this.name01 = userInfo.name01;
      this.name02 = userInfo.name02;
      this.kana01 = userInfo.kana01;
      this.kana02 = userInfo.kana02;
      this.tel01 = userInfo.tel01;
      this.tel02 = userInfo.tel02;
      this.tel03 = userInfo.tel03;
      this.zip = "" + userInfo.zip01 + userInfo.zip02;
      this.address01 = userInfo.addr01;
      this.address02 = userInfo.addr02;
      this.pref = userInfo.pref;
      this.yagou = userInfo.company_name;
      this.busyo = userInfo.department_name;
    }

    if( fbUserData && "isIndividual" in fbUserData && fbUserData.isIndividual ){
      this.isIndividual = "true";
    }

    if( fbUserData && "representative" in fbUserData && fbUserData.representative ){
      this.representative = fbUserData.representative;
    }
  },
  data() {
    return {
      isIndividual: "",
      name01: "",
      name02: "",
      kana01: "",
      kana02: "",
      email: "",
      tel01: "",
      tel02: "",
      tel03: "",
      address01: "",
      address02: "",
      zip: "",
      yagou: "",
      representative: "",
      password: "",
      isLoading: false,
      isEnd: false,
      pref: "default",
      busyo: "",
      name01error: false,
      name01ErrorText: "",
      name02error: false,
      name02ErrorText: "",
      kana01error: false,
      kana01ErrorText: "",
      kana02error: false,
      kana02ErrorText: "",
      tel01error: false,
      tel02error: false,
      tel03error: false,
      telErrorText: "",
      address01error: false,
      ziperror: false,
      yagouerror: false,
      yagouErrorText: "",
      representativeerror: false,
      busyoerror: false,
      busyoErrorText: "",
      preferror: false,
    };
  },
  watch: {
    isIndividual(){
      this.yagouerror = false;
    },
    name01() {
      this.name01error = false;
    },
    name02() {
      this.name02error = false;
    },
    kana01() {
      this.kana01error = false;
    },
    kana02() {
      this.kana02error = false;
    },
    tel01() {
      this.tel01error = false;
    },
    tel02() {
      this.tel02error = false;
    },
    tel03() {
      this.tel03error = false;
    },
    address01() {
      this.address01error = false;
    },
    zip() {
      this.ziperror = false;
    },
    yagou() {
      this.yagouerror = false;
    },
    representative() {
      this.representativeerror = false;
    },
    busyo() {
      this.busyoerror = false;
    },
  },
  methods: {
    contact() {
      router.push("/contact");
    },
    backhome() {
      router.push("/");
    },
    inputCheck() {
      const spaceRegex = /\s/;
      const kanaRegex = /^[\u30A0-\u30FF\u30FC]+$/;
      const numberRegex = /^\d+$/;

      var errorExist = false;
      if (!this.name01) {
        errorExist = true;
        this.name01error = true;
        this.name01ErrorText = "姓を入力してください";
      }else{
        // 空白チェック
        if( spaceRegex.test(this.name01) ){
          errorExist = true;
          this.name01error = true;
          this.name01ErrorText = "空白を含めないでください";
        }
      }
      if (!this.name02) {
        errorExist = true;
        this.name02error = true;
        this.name02ErrorText = "名を入力してください";
      }else{
        // 空白チェック
        if( spaceRegex.test(this.name02) ){
          errorExist = true;
          this.name02error = true;
          this.name02ErrorText = "空白を含めないでください";
        }
      }
      if (!this.kana01) {
        errorExist = true;
        this.kana01error = true;
        this.kana01ErrorText = "セイを入力してください";
      }else{
        // 空白チェック
        if( spaceRegex.test(this.kana01) ){
          errorExist = true;
          this.kana01error = true;
          this.kana01ErrorText = "空白を含めないでください";
        }
        // カタカナチェック
        if( !kanaRegex.test(this.kana01) ){
          errorExist = true;
          this.kana01error = true;
          this.kana01ErrorText = "カタカナで入力してください";
        }
      }
      if (!this.kana02) {
        errorExist = true;
        this.kana02error = true;
        this.kana02ErrorText = "メイを入力してください";
      }else{
        // 空白チェック
        if( spaceRegex.test(this.kana02) ){
          errorExist = true;
          this.kana02error = true;
          this.kana02ErrorText = "空白を含めないでください";
        }
        // カタカナチェック
        if( !kanaRegex.test(this.kana02) ){
          errorExist = true;
          this.kana02error = true;
          this.kana02ErrorText = "カタカナで入力してください";
        }
      }
      if (!this.tel01) {
        errorExist = true;
        this.tel01error = true;
        this.telErrorText = "内容を記載してください";
      }
      if (!this.tel02) {
        errorExist = true;
        this.tel02error = true;
        this.telErrorText = "内容を記載してください";
      }
      if (!this.tel03) {
        errorExist = true;
        this.tel03error = true;
        this.telErrorText = "内容を記載してください";
      }

      if( this.tel01 && this.tel02 && this.tel03 ){
        if( !numberRegex.test(this.tel01) ){
          errorExist = true;
          this.tel01error = true;
          this.telErrorText = "数字のみで入力してください";
        }
        if( !numberRegex.test(this.tel02) ){
          errorExist = true;
          this.tel02error = true;
          this.telErrorText = "数字のみで入力してください";
        }
        if( !numberRegex.test(this.tel03) ){
          errorExist = true;
          this.tel03error = true;
          this.telErrorText = "数字のみで入力してください";
        }
      }

      if (!this.zip) {
        errorExist = true;
        this.ziperror = true;
      }
      if (!this.pref) {
        errorExist = true;
        this.preferror = true;
      }
      if (!this.address01) {
        errorExist = true;
        this.address01error = true;
      }

      if(!this.isIndividual){
        if (!this.yagou) {
          errorExist = true;
          this.yagouerror = true;
          this.yagouErrorText = "会社名を入力してください";
        }else{
          // 空白チェック
          if( spaceRegex.test(this.yagou) ){
            errorExist = true;
            this.yagouerror = true;
            this.yagouErrorText = "空白を含めないでください";
          }
        }

        if (!this.representative) {
          errorExist = true;
          this.representativeerror = true;
        }

        if (!this.busyo) {
          errorExist = true;
          this.busyoerror = true;
          this.busyoErrorText = "部署名を入力してください";
        }else{
          // 空白チェック
          if( spaceRegex.test(this.busyo) ){
            errorExist = true;
            this.busyoerror = true;
            this.busyoErrorText = "空白を含めないでください";
          }
        }
      }else{
        if (this.yagou) {
          // 空白チェック
          if( spaceRegex.test(this.yagou) ){
            errorExist = true;
            this.yagouerror = true;
            this.yagouErrorText = "空白を含めないでください";
          }
        }
      }

      return !errorExist;
    },
    async sendAction() {
      // 入力チェック
      if (!this.inputCheck()) {
        return;
      }

      // 個人の場合は部署と代表者情報が入らないので削除
      if(this.isIndividual){
        // 個人
        this.representative = "";
        this.busyo = "";
      }

      // 登録
      this.$store.commit("showLoading");
      let store = this.$store;
      var isError = false;
      this.email = firebase.auth().currentUser.email;

      await User.authPartnerCode("XXXXXXXX").catch(function () {
        store.commit("hideLoading");
        store.commit("showMessage", "更新エラー");
        isError = true;
      });

      if (!isError) {
        await User.registFBAcryProInfo({
          isIndividual: Boolean(this.isIndividual),
          representative: this.representative,
        }).catch(function () {
          store.commit("hideLoading");
          store.commit("showMessage", "更新エラー");
          isError = true;
        });

        if (!isError) {
          await User.registInfo({
            name01: this.name01,
            name02: this.name02,
            kana01: this.kana01,
            kana02: this.kana02,
            tel01: this.tel01,
            tel02: this.tel02,
            tel03: this.tel03,
            addr01: this.address01,
            addr02: this.address02,
            zip01: this.zip.substring(0, 3),
            zip02: this.zip.substring(3, 7),
            company_name: this.yagou,
            department_name:this.busyo,
            pref: this.pref,
            email: this.email,
          }).catch(() => {
            store.commit("hideLoading");
            store.commit("showMessage", "更新エラー");
            isError = true;
          });
          if (!isError) {
            Analytics.piiFormCompleted();
            store.commit("hideLoading");
            router.push("/contract");
          }
        }
      }
    },
    findAction() {
      let YubinBango = require("yubinbango-core2");
      new YubinBango.Core(this.zip, (addr) => {
        this.pref = addr.region_id;
        console.log(addr.locality);
        console.log(addr.street);
        this.address01 = `${addr.locality}${addr.street}`;
        this.address02 = "";
      });
    },
  },
};
</script>

<style scoped>
.login {
  width: 400px;
  height: 300px;
}
.acry-input {
  width: 300px;
  height: 40px;
  padding-left: 10px;
}
.mustlbl {
  color: white;
  background: #bc6665;
  border-radius: 3px;
  padding: 5px 12px 5px 12px;
}
.acry-input-error {
  border: 1px solid #bc6665;
}
.acry-normal-btn :hover {
  color: white;
}
.error-lbl {
  color: #bc6665;
}
.find-btn {
  width: 100px;
  height: 40px;
  color: white;
  background: #8c9bc6;
  border-radius: 4px;
  border: none;
  font-weight: bold;
}
</style>
